import { cn } from '@/lib/utils';
import { FC } from 'react';
import { OrderStatus } from '@/features/orders/types/orders-dto';
import { ordersUtils } from '@/features/orders/utils/ordersUtils';

type Props = {
	status: OrderStatus;
};

const OrderStatusBar: FC<Props> = ({ status }) => {
	const orderFlow = ordersUtils.getStepsToShow(status);

	const stepsToShow = orderFlow.map((status) => {
		const { label, icon, iconStyles } = ordersUtils.getStatusData(status);
		return {
			label,
			icon,
			iconStyles,
		};
	});

	return (
		<div className='relative flex'>
			<div className='absolute w-44 top-[23px] left-1/2 -translate-x-1/2 border-t border-popover-100' />
			{stepsToShow.map(({ label, icon: Icon, iconStyles }) => (
				<div
					key={label}
					className='w-1/3 flex flex-col items-center gap-1'>
					<div
						className={`w-fit p-3 z-50 border border-popover-100 rounded-full bg-popover-10`}>
						<Icon
							className={cn(
								`${
									label.replace(' p', 'P') ===
									OrderStatus[status]
										? iconStyles
										: 'fill-popover-400'
								}`,
							)}
						/>
					</div>
					<span
						className={cn(
							`text-sm ${
								label.replace(' p', 'P') === OrderStatus[status]
									? ''
									: 'text-popover-400'
							}`,
						)}>
						{label}
					</span>
				</div>
			))}
		</div>
	);
};

export default OrderStatusBar;
